function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.01 17.997l-2.873-2.773h6.95a.904.904 0 00.646-.268.917.917 0 00.267-.65v-.614a.922.922 0 00-.564-.85.908.908 0 00-.35-.069h-6.949l2.874-2.772a.921.921 0 00.015-1.314l-.418-.417a.91.91 0 00-.995-.2.909.909 0 00-.295.2l-5.05 5.077a.916.916 0 00-.198 1 .916.916 0 00.198.298l5.05 5.085a.909.909 0 001.29 0l.418-.417a.925.925 0 00.19-1.017.925.925 0 00-.205-.3zM4.99 2.003l2.873 2.773H.913a.906.906 0 00-.844.567.922.922 0 00-.069.352v.613a.922.922 0 00.564.85c.11.046.23.07.35.069h6.949L4.989 9.999a.92.92 0 00-.015 1.314l.419.417a.91.91 0 00.994.2.91.91 0 00.295-.2l5.05-5.077a.915.915 0 00.198-1 .915.915 0 00-.198-.298L6.682.27a.91.91 0 00-.994-.2.91.91 0 00-.295.2l-.419.417a.925.925 0 00-.19 1.017.924.924 0 00.205.3z",
  fill: "params(fill) #00478C"
});

function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCompare;